var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition-group",
    { attrs: { name: "fade" } },
    [
      _c(
        "b-container",
        { key: "container", staticClass: "py-4" },
        [
          _c(
            "base-card",
            {
              key: "appointment-history",
              staticClass: "mb-4",
              attrs: { title: _vm.$t("appointmentsHistory") }
            },
            [_c("appointment-history")],
            1
          ),
          _vm._v(" "),
          _vm.variables
            ? _c(
                "base-card",
                {
                  key: "health-variables",
                  staticClass: "mb-4",
                  attrs: { title: _vm.$t("healthvariables") }
                },
                _vm._l(_vm.basicVariables, function(item, propName) {
                  return _c("clinic-history-variable", {
                    key: propName,
                    staticClass: "mb-2",
                    attrs: {
                      rawData: item,
                      name: propName,
                      value: item.values,
                      date: item.dateTime,
                      variableName: item.variableName,
                      editable: _vm.isEditable(propName) && !_vm.$route.query.h,
                      graphEnabled: _vm.hasGraph(propName)
                    }
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.variables
            ? _c(
                "base-card",
                {
                  key: "additional-health-variables",
                  staticClass: "mb-4",
                  attrs: { title: _vm.$t("additional-health-variables") }
                },
                _vm._l(_vm.additionalVariables, function(item, propName) {
                  return _c("clinic-history-variable", {
                    key: propName,
                    staticClass: "mb-2",
                    attrs: {
                      rawData: item,
                      name: propName,
                      value: item.values,
                      date: item.dateTime,
                      variableName: item.variableName,
                      editable: _vm.isEditable(propName) && !_vm.$route.query.h,
                      graphEnabled: _vm.hasGraph(propName),
                      slider: ""
                    }
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "base-card",
            {
              key: "observations",
              staticClass: "mb-4",
              attrs: { title: _vm.$t("observations") }
            },
            [
              _c("base-textarea", {
                attrs: {
                  placeholder: _vm.$t("observations-ph"),
                  rows: 3,
                  maxRows: 9
                },
                model: {
                  value: _vm.observations,
                  callback: function($$v) {
                    _vm.observations = $$v
                  },
                  expression: "observations"
                }
              }),
              _vm._v(" "),
              !_vm.$route.query.h
                ? _c("base-button", { on: { click: _vm.saveObservations } }, [
                    _vm._v(_vm._s(_vm.$t("save-btn")))
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("history-chrondiseases-section", {
            key: "chrondiseases",
            staticClass: "mb-4"
          }),
          _vm._v(" "),
          _c("history-diseases-section", {
            key: "diseases",
            staticClass: "mb-4"
          }),
          _vm._v(" "),
          _c("history-allergies-section", {
            key: "allergies",
            staticClass: "mb-4"
          }),
          _vm._v(" "),
          _c("history-med-allergies-section", {
            key: "medallergies",
            staticClass: "mb-4"
          }),
          _vm._v(" "),
          _c("history-medicines-section", {
            key: "medicines",
            staticClass: "mb-4"
          }),
          _vm._v(" "),
          _c("history-vaccines-section", {
            key: "vaccines",
            staticClass: "mb-4"
          }),
          _vm._v(" "),
          _c("history-familybackgrounds-section", {
            key: "familybackgrounds",
            staticClass: "mb-4"
          }),
          _vm._v(" "),
          _c("history-files-section", { key: "files", staticClass: "mb-4" })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7804c552", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7804c552","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ClinicHistory.vue
// module id = 2754
// module chunks = 28 34 141